module.exports = __webpack_public_path__ + "static/logo-brown.7f05d78c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-brown.png
// module id = 321
// module chunks = 168707334958949